// extracted by mini-css-extract-plugin
module.exports = {"priceText":"CollectorsTable_priceText__KN_y8","brand06Text":"CollectorsTable_brand06Text__4uR9k","avatarArea":"CollectorsTable_avatarArea__eFiQo"};